var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol_wrapper"},[_c('div',{staticClass:"title"},[_vm._v("Updated: "+_vm._s(_vm.value.updatedAt))]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.value.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }